(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var widget = document.getElementById('bopi-game');
    if (!widget) return;

    var duration = parseInt(widget.getAttribute('data-duration'), 10) || 15;
    var resultTemplate = widget.getAttribute('data-result-template') || 'You popped %n% bites!';

    var arena = document.getElementById('game-arena');
    var startScreen = document.getElementById('game-start');
    var startBtn = document.getElementById('game-start-btn');
    var resultScreen = document.getElementById('game-result');
    var resultText = document.getElementById('game-result-text');
    var replayBtn = document.getElementById('game-replay-btn');
    var scoreEl = document.getElementById('game-score');
    var timerEl = document.getElementById('game-timer');

    var score = 0;
    var timeLeft = duration;
    var spawnTimer = null;
    var countdownTimer = null;
    var activeBugs = [];
    var running = false;

    startBtn.addEventListener('click', startGame);
    replayBtn.addEventListener('click', startGame);

    function startGame() {
      score = 0;
      timeLeft = duration;
      scoreEl.textContent = score;
      timerEl.textContent = timeLeft;
      running = true;

      startScreen.hidden = true;
      resultScreen.hidden = true;
      clearBugs();

      spawnTimer = setInterval(spawnBug, 750);
      countdownTimer = setInterval(function () {
        timeLeft -= 1;
        timerEl.textContent = Math.max(timeLeft, 0);
        if (timeLeft <= 0) endGame();
      }, 1000);

      spawnBug();
    }

    function endGame() {
      running = false;
      clearInterval(spawnTimer);
      clearInterval(countdownTimer);
      clearBugs();

      resultText.textContent = resultTemplate.replace('%n%', score);
      resultScreen.hidden = false;
    }

    function clearBugs() {
      activeBugs.forEach(function (b) {
        if (b.el.parentNode) b.el.parentNode.removeChild(b.el);
        clearTimeout(b.timeout);
      });
      activeBugs = [];
    }

    function spawnBug() {
      if (!running) return;

      var bounds = arena.getBoundingClientRect();
      var size = 44;
      var maxX = Math.max(bounds.width - size, 10);
      var maxY = Math.max(bounds.height - size, 10);
      var x = Math.random() * maxX;
      var y = Math.random() * maxY;

      var bug = document.createElement('button');
      bug.type = 'button';
      bug.className = 'game-bug';
      bug.style.left = x + 'px';
      bug.style.top = y + 'px';
      bug.setAttribute('aria-label', 'Pop the mosquito');
      bug.textContent = '🦟';

      var entry = { el: bug, timeout: null };

      bug.addEventListener('click', function () {
        if (bug.classList.contains('is-popped')) return;
        bug.classList.add('is-popped');
        score += 1;
        scoreEl.textContent = score;
        setTimeout(function () {
          if (bug.parentNode) bug.parentNode.removeChild(bug);
        }, 200);
        activeBugs = activeBugs.filter(function (b) { return b !== entry; });
      });

      entry.timeout = setTimeout(function () {
        if (bug.parentNode) bug.parentNode.removeChild(bug);
        activeBugs = activeBugs.filter(function (b) { return b !== entry; });
      }, 1600);

      activeBugs.push(entry);
      arena.appendChild(bug);
    }
  });
})();
